/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Subject, takeUntil, filter } from 'rxjs';

import { CoreConfigService } from '../../../../../services';

@Component({
  selector: '[xbaht-core-menu-horizontal-collapsible]',
  templateUrl: './collapsible.component.html',
  styleUrl: './collapsible.component.scss',
  standalone: false
})
export class CoreMenuHorizontalCollapsibleComponent
  implements OnInit, OnDestroy
{
  public coreConfig: any;
  public isShow = false;

  @HostBinding('class.active')
  @HostBinding('class.open')
  @HostBinding('class.sidebar-group-active')
  public isActive = false;

  @HostListener('mouseenter')
  public show(): void {
    this.isShow = true;
    this.setSubMenuProp();
  }

  @HostListener('mouseleave')
  public hide(): void {
    this.isShow = false;
  }

  @Input()
  public item: any;

  private _unsubscribe: Subject<void>;

  constructor(
    private el: ElementRef,
    private _router: Router,
    private _coreConfigService: CoreConfigService,
  ) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;
      });

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._unsubscribe)
      )
      .subscribe((event: any) => {
        if (this.confirmUrlInChildren(this.item, event.urlAfterRedirects)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      });

    if (this.confirmUrlInChildren(this.item, this._router.url)) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  public setSubMenuProp(): void {
    setTimeout(() => {
      const nativeElement = this.el.nativeElement,
        nativeElementChildren = this.el.nativeElement.children[1];

      if (nativeElement.classList.contains('dropdown-submenu')) {
        const innerHeight = window.innerHeight,
          dropdownTop = nativeElementChildren.getBoundingClientRect().top,
          dropdownLeft = nativeElementChildren.getBoundingClientRect().left,
          dropdownHeight = nativeElementChildren.scrollHeight,
          dropdownWidth = nativeElementChildren.scrollWidth;

        if (innerHeight - dropdownTop - dropdownHeight - 28 < 1) {
          const maxHeight = innerHeight - dropdownTop - 25;
          nativeElementChildren.setAttribute(
            'style',
            'overflow-y: auto; overflow-x: hidden; max-height : ' +
              maxHeight +
              'px'
          );
        }

        if (dropdownLeft + dropdownWidth - (window.innerWidth - 16) >= 0) {
          nativeElementChildren.parentElement.classList.add('openLeft');
        }
      }
    });
  }

  public confirmUrlInChildren(
    parent: { children: any },
    url: string | any[]
  ): boolean {
    const children = parent.children;

    if (!children) {
      return false;
    }

    for (const child of children) {
      if (child.children) {
        if (this.confirmUrlInChildren(child, url)) {
          return true;
        }
      }

      if (child.url === url || url.includes(child.url)) {
        return true;
      }
    }

    return false;
  }
}
